import React, { useEffect } from 'react'
import { SearchIncidents } from '../components/SearchIncidents'

const IncidentsPage: React.FC = () => {
  useEffect(() => {
    document.title = 'PFS Return to Pay'
  }, [])

  return (
    <div className="s-reported-incidents-dashboard ln-u-1/1">
      <div className="ln-u-margin-top*3">
        <SearchIncidents />
      </div>
    </div>
  )
}

export default IncidentsPage
